import { createParamLabelsView } from '../../builder-selection';
import { currentBuilderState } from '../builder.state';
import { ParametersView } from '../model/parameters-view.model';

import { createParams } from './create-params.function';

export function updateSectionLabels(next: ParametersView = null): void {
    const state = currentBuilderState();
    const vp = state.viewParams;

    if (next != null) {
        vp.role?.forEach((e) => {
            e.label = next.role?.find((ee) => ee.id === e.id)?.label ?? e.label;
        });
        vp.team?.forEach((e) => {
            e.label = next.team?.find((ee) => ee.id === e.id)?.label ?? e.label;
        });
        vp.individual?.forEach((e) => {
            e.label =
                next.individual?.find((ee) => ee.id === e.id)?.label ?? e.label;
        });
        vp.site?.forEach((e) => {
            e.label = next.site?.find((ee) => ee.id === e.id)?.label ?? e.label;
        });
        vp.queue?.forEach((e) => {
            e.label =
                next.queue?.find((ee) => ee.id === e.id)?.label ?? e.label;
        });
        vp.superGroup?.forEach((e) => {
            e.label =
                next.superGroup?.find((ee) => ee.id === e.id)?.label ?? e.label;
        });
    }

    const bp = createParams();

    if (bp.periodType != null) {
        bp.periodType.text = vp.periodType?.text;
    }

    if (bp.roles?.[0] != null) {
        bp.roles[0].fullName = vp.role?.[0]?.label;
    }

    if (bp.teams?.[0] != null) {
        bp.teams[0].firstName = vp.team?.[0]?.label;
        bp.teams[0].lastName = '';
    }

    if (bp.individuals?.[0] != null) {
        bp.individuals[0].firstName = vp.individual?.[0]?.label;
        bp.individuals[0].lastName = '';
    }

    if (bp.sites?.[0] != null) {
        bp.sites[0].fullName = vp.site?.[0]?.label;
    }

    if (bp.queues?.[0] != null) {
        bp.queues[0].fullName = vp.queue?.[0]?.label;
    }

    if (bp.superGroups?.[0] != null) {
        bp.superGroups[0].fullName = vp.superGroup?.[0]?.label;
    }

    bp.metrics?.forEach((e) => {
        e.fullName = vp.metrics?.find((ee) => ee.id === e.id)?.fullName;
    });

    state.viewParamLabels = createParamLabelsView(bp);
}
